import { render } from "./tw-histogram.vue?vue&type=template&id=1eea49f0"
import script from "./tw-histogram.vue?vue&type=script&lang=js"
export * from "./tw-histogram.vue?vue&type=script&lang=js"
script.render = render

export default script